import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const IntegrationIcon = React.memo(function IntegrationIcon(props: TIntegrationIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Integration" {...props}>
            <path d="M18.9062 2.40625H3.09375C2.71348 2.40625 2.40625 2.71348 2.40625 3.09375V18.9062C2.40625 19.2865 2.71348 19.5938 3.09375 19.5938H18.9062C19.2865 19.5938 19.5938 19.2865 19.5938 18.9062V3.09375C19.5938 2.71348 19.2865 2.40625 18.9062 2.40625ZM18.0469 18.0469H3.95312V3.95312H18.0469V18.0469ZM6.54844 11.2578H7.6377C7.71719 11.2578 7.78379 11.1934 7.78379 11.1117V9.4166C7.78379 8.99336 8.12539 8.65176 8.54648 8.65176H12.9658V9.79902C12.9658 9.92148 13.1055 9.98809 13.2 9.91289L15.5439 8.07168C15.6191 8.01367 15.6191 7.8998 15.5439 7.8418L13.2 6.00059C13.1055 5.92539 12.9658 5.99414 12.9658 6.11445V7.26172H8.54434C7.36055 7.26172 6.40234 8.22422 6.40234 9.4123V11.1074C6.40234 11.1934 6.4668 11.2578 6.54844 11.2578ZM6.4582 14.1561L8.80215 15.9973C8.89668 16.0725 9.03633 16.0037 9.03633 15.8834V14.7361H13.4557C14.6395 14.7361 15.5977 13.7736 15.5977 12.5855V10.8904C15.5977 10.8109 15.5332 10.7443 15.4516 10.7443H14.3623C14.2828 10.7443 14.2162 10.8088 14.2162 10.8904V12.5855C14.2162 13.0088 13.8746 13.3504 13.4535 13.3504H9.03633V12.2031C9.03633 12.0807 8.89668 12.0141 8.80215 12.0893L6.4582 13.9305C6.38301 13.9842 6.38301 14.098 6.4582 14.1561V14.1561Z" />
        </IconBase>
    );
});

export default IntegrationIcon;

// #region Types

export type TIntegrationIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <IntegrationIcon /> : { ...IconBaseExample, render: IntegrationIcon };

// #endregion
